import axios from "axios";
import Firebase from 'firebase/app'
import 'firebase/auth'

const state = {
  keyboardConfig: {}
};

const getters = {
  keyboardConfig: state => {
    return state.keyboardConfig;
  }
};

const mutations = {
  setKeyboardConfig: (state, payload) => {
    state.keyboardConfig = payload;
  },
};

function authenticate() {
  let useFirebase = false;
  if (useFirebase) {
    return Firebase.auth().currentUser.getIdToken(true);
  } else {
    return new Promise((resolve, reject) => {
      resolve(
        "eyJhbGciOiJSUzI1NiIsImtpZCI6IjdkMmY5ZjNmYjgzZDYzMzc0OTdiNmY3Y2QyY2ZmNGRmYTVjMmU4YjgiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vdGV4dGxhYmVsLWE5MDVkIiwiYXVkIjoidGV4dGxhYmVsLWE5MDVkIiwiYXV0aF90aW1lIjoxNTU0NjUyMzczLCJ1c2VyX2lkIjoiTWxRM1hBUml3R2ZkUUpldXZGWnlSQ1NWREVGMiIsInN1YiI6Ik1sUTNYQVJpd0dmZFFKZXV2Rlp5UkNTVkRFRjIiLCJpYXQiOjE1NTQ2NTIzNzgsImV4cCI6MTU1NDY1NTk3OCwiZW1haWwiOiJtYXRoaWV1QHByaXZhdGVseS5ldSIsImVtYWlsX3ZlcmlmaWVkIjpmYWxzZSwiZmlyZWJhc2UiOnsiaWRlbnRpdGllcyI6eyJlbWFpbCI6WyJtYXRoaWV1QHByaXZhdGVseS5ldSJdfSwic2lnbl9pbl9wcm92aWRlciI6InBhc3N3b3JkIn19.oTvPqGTnjrL6aVansIKfFhYfzdm3FMLKA2jyCpkBq2Cj7zsuchWNSjfnYV_R0VeIhXfyW9HN9rdxCEufyPXKiNyFfqsaT8R8d4Curw0IDtNS7ZMOj66XIqttjkHuJqabFqwLu8N7nTIH2-loGfRUSc1uNRgyiKWaDAF6jHtyRpTU2AiBsMxHZQvWw19FN46-TGojd120QYcCSU3NQqevRN6ZbCjT2ata5CkwhPalj_WTMxo75EpOPVTz_QH_8mVy73-35BDba0_wVqT4IGA7K6WPuI3di32_NF1uqT28AmLEueXnHee43ZTfjr1EPdzr2TKQ-9JqHgWhj_TfopWh0g"
      );
    });
  }
}

const actions = {
  autocompleteText: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      // we get the token that can be verified at the server
      authenticate()
        .then(function(idToken) {
          payload.idToken = idToken;
          // Send token to backend via HTTPS
          axios
            .post("/autocomplete", payload)
            .then(function(results) {
              resolve(results);
            })
            .catch(function(error) {
              if (error) {
                reject(new Error("cannot autocomplete texts"));
              }
            });
        })
        .catch(function() {
          // Handle error
        });
    });
  },
  autocorrectText: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      // we get the token that can be verified at the server
      authenticate()
        .then(function(idToken) {
          // Send token to backend via HTTPS
          axios
            .post("/autocorrect", {
              text: payload.text,
              idToken: idToken
            })
            .then(function(results) {
              resolve(results);
            })
            .catch(function(error) {
              if (error) {
                reject(new Error("cannot autocorrect texts"));
              }
            });
        })
        .catch(function() {
          // Handle error
        });
    });
  },
  getKeyboardSettings: ({ commit }) => {
    return new Promise((resolve, reject) => {
      // we get the token that can be verified at the server
      authenticate()
        .then(function(idToken) {
          // Send token to backend via HTTPS
          axios
            .get("/keyboardSettings", {
              params: { idToken: idToken }
            })
            .then(function(results) {
              commit("setKeyboardConfig", results.data.keyboardConfig);
              resolve();
            })
            .catch(function(error) {
              if (error) {
                reject(new Error("cannot fetch keyboard settings"));
              }
            });
        })
        .catch(function() {
          // Handle error
        });
    });
  }
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
};
